import { hasFocusVisible } from 'Functions/helpers';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

if (!hasFocusVisible()) {
    document.body.classList.add('without-focus-visible')
}